import './styles/font-faces.css';

import { FC } from 'react';
import classNames from 'classnames';
import { AlchemyProvider } from '@m/alchemy-ui/AlchemyProvider';
import { CssInterpolation, NAMESPACE, theme } from '@m/alchemy-ui/theme';

interface AlchemyPageProps {
  className?: string;
  noVerticalMargins?: boolean;
  noHorizontalMargins?: boolean;
  children: React.ReactNode;
  globalStyles?: CssInterpolation;
}

const AlchemyPage: FC<AlchemyPageProps> = ({
  children,
  className: rawClassName,
  noVerticalMargins = false,
  noHorizontalMargins = false,
  globalStyles,
}) => {
  const className = classNames(
    { 'margin-vertical-largish': !noVerticalMargins },
    { 'margin-horizontal-medium': !noHorizontalMargins },
    rawClassName,
    NAMESPACE
  );

  return (
    <AlchemyProvider
      theme={theme}
      namespace={NAMESPACE}
      globalCss={globalStyles}
    >
      <div className={className}>{children}</div>
    </AlchemyProvider>
  );
};

export default AlchemyPage;
